interface TabBarProps {
  tabs: { key: string; label: string; badge?: number | null }[];
  activeTab: string;
  onTabChange: (key: string) => void;
}

export function TabBar({ tabs, activeTab, onTabChange }: TabBarProps) {
  return (
    <div className="tabs" style={{ marginBottom: 'var(--s16)' }}>
      {tabs.map(t => (
        <button
          key={t.key}
          className={`tab${activeTab === t.key ? ' active' : ''}`}
          onClick={() => onTabChange(t.key)}
        >
          {t.label}
          {t.badge != null && t.badge > 0 && (
            <span
              style={{
                marginLeft: 6,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: 18,
                height: 18,
                padding: '0 5px',
                borderRadius: 9,
                background: 'var(--accent)',
                color: 'var(--surface)',
                fontSize: 10,
                fontWeight: 700,
                verticalAlign: 'middle',
              }}
            >
              {t.badge}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
